<div *ngIf="systemMessage" class="system-message-banner" role="alert" aria-live="polite">
  <mat-icon aria-hidden="true">info</mat-icon>
  <span>{{ systemMessage.message }}</span>
</div>
